<template>
  <v-form ref="form" flat class="pt-5">
    <v-row>
      <!-- <v-col cols="12" md="6">
        <DateIOSPicker
          label="Ngày"
          :date.sync="time"
          outlined
          class="required"
          :rules="[$rules.required, $rules.date, $rules.dateFromNow]"
          dense
        />
      </v-col> -->
      <!-- <v-col cols="12" md="6"></v-col> -->
      <!-- <v-col cols="12" md="6" class="py-0">
        <AutocompleteGrade
          v-model="grade"
          return-object
          label="Khối"
          class="required"
          :rules="[$rules.required]"
          outlined
          dense
          @change="gradeChanged"
        />
      </v-col>
      <v-col cols="12" md="6" class="py-0">
        <AutocompleteClass
          v-model="classData"
          return-object
          label="Lớp"
          class="required"
          :rules="[$rules.required]"
          outlined
          dense
          clearable
          :filter="gradeId"
          @change="classChanged"
        />
      </v-col> -->
      <v-col cols="12" md="12">
        <AutocompleteStudent
          :syncedValue.sync="student"
          return-object
          label="Học sinh"
          class="required"
          :rules="[$rules.required]"
          hide-details="auto"
          outlined
          dense
          clearable
          :filter="currentClasId"
        />
      </v-col>
      <v-col cols="12" md="12">
        <RadioViolation :violation.sync="type" @change="type = $event" mandatory />
      </v-col>
      <v-col cols="12" md="12">
        <v-textarea
          class="required"
          :rules="[$rules.required]"
          v-model="description"
          label="Nội dung"
          hide-details="auto"
          outlined
          dense
        ></v-textarea>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import AutocompleteStudent from '@/components/basic/input/AutocompleteStudent.vue'
import RadioViolation from '@/views/violation/components/RadioViolation.vue'
import { mapState } from 'vuex'
import { get } from 'lodash'
import moment from 'moment'

export default {
  components: {
    AutocompleteStudent,
    RadioViolation
  },
  data: () => ({
    grade: '',
    classData: '',
    student: {},
    description: '',
    type: '',
    time: moment().toISOString()
  }),
  computed: {
    ...mapState('app', ['currentSemester']),
    ...mapState('ClassNoteDetail', ['slot']),

    currentClasId() {
      return { currentClass: get(this.slot.class, 'id') }
    }
  },
  props: {},
  methods: {
    reset() {
      this.grade = null
      this.classData = null
      this.student = null
      this.description = null
      this.time = moment().toISOString()
      this.type = 'commendation'

      this.$refs.form.resetValidation()
    },
    validate() {
      return this.$refs.form.validate()
    },
    resetValidation() {
      this.$refs.form.resetValidation()
    },
    getData() {
      if (this.$refs.form.validate()) {
        return {
          grade: this.student.grade,
          description: this.description,
          student: this.student.id,
          class: this.student.currentClass,
          type: this.type,
          semester: this.currentSemester.id
        }
      }
    },
    resetDefault() {
      if (this.violation) {
        this.description = this.violation.description
        this.student = this.violation.student
        this.type = this.violation.type
      } else {
        this.reset()
      }
    }
  }
}
</script>
<style scoped></style>>
